import { SlackConnectionStatus } from '../../../reducers/integrationsReducer';
import { SlackActionType } from '../../../types/enums/SlackActionType';
import { TeamsRecipientType } from '../teams/types';
import { SlackConstant } from './utils';

const isButtonTextValid = (buttonText: string = '') => Boolean(buttonText.trim());

const validateSlackActionUpdate = (action: UpdateRecordSlackAction) => {
  return isButtonTextValid(action.buttonText) && action.fields.length > 0;
};

const validateSlackActionCreate = (action: CreateRecordSlackAction) => {
  if (action.fields.length === 0) {
    return false;
  }
  if (!isButtonTextValid(action.buttonText)) {
    return false;
  }
  if (action.relationshipField !== undefined) {
    if (action.relationshipField.length !== 1) {
      return false;
    }
  }
  if (action.objectTypeName.recordType !== undefined) {
    if (action.objectTypeName.recordType.name === '') {
      return false;
    }
  }

  if (action.relationshipField !== undefined) {
    if (action.relationshipField.length !== 1) {
      return false;
    }
    if (action.relationshipField[0] === '') {
      return false;
    }
  }

  return true;
};

const validateSlackActionLink = (action: LinkButtonSlackAction) => {
  if (!isButtonTextValid(action.buttonText)) {
    return false;
  }
  if (!action?.url?.template && !action?.url?.variables?.length) {
    return false;
  }
  return true;
};

const validateSlackAction = (action: SlackAction) => {
  switch (action.type) {
    case SlackActionType.UPDATE_RECORD:
      return validateSlackActionUpdate(action);
    case SlackActionType.CREATE_RECORD:
      return validateSlackActionCreate(action);
    case SlackActionType.LINK_BUTTON:
      return validateSlackActionLink(action);
    default:
      return false;
  }
};

export const validateSlackActionParams = (
  slackStatus: SlackConnectionStatus,
  actionParams?: DeepPartial<AutomationSlackActionParams>,
) => {
  if (slackStatus !== SlackConnectionStatus.Connected) {
    return false;
  }

  if (actionParams?.actions) {
    const isValid = actionParams.actions.every(validateSlackAction);
    if (!isValid) {
      return false;
    }
  }
  if (actionParams?.recipients && actionParams?.recipients.length > 0) {
    return true;
  }

  return false;
};

export const validateSlackChannelRef = (
  action: DeepPartial<
    | SlackArchiveDealroomAutomationAction
    | SlackRenameDealroomAutomationAction
    | SlackAddMemberAutomationAction
  >,
) => {
  return (
    action.actionParams?.channelRef?.type === SlackConstant.Sweep_Created_Slack_Channel ||
    (action.actionParams?.channelRef?.type === SlackConstant.Salesforce_Created_Slack_Channel &&
      action.actionParams?.channelRef?.value?.fieldIds &&
      action.actionParams?.channelRef?.value?.fieldIds?.length > 0)
  );
};

export const validateTeamsChannelRef = (
  action: DeepPartial<
    | TeamsAddMemberAutomationAction
    | TeamsRenameDealroomAutomationAction
    | TeamsArchiveDealroomAutomationAction
  >,
) => {
  //TODO: add rename and archive dealroom when ready in the backend
  return (
    action.actionParams?.channelRef?.type === TeamsRecipientType.CHANNEL_STORED_IN_SWEEP ||
    (action.actionParams?.channelRef?.type ===
      TeamsRecipientType.CHANNEL_STORED_IN_SALESFORCE_FIELD &&
      action.actionParams?.channelRef?.value?.fieldIds &&
      action.actionParams?.channelRef?.value?.fieldIds?.length > 0)
  );
};
